import { render, staticRenderFns } from "./TrainingQuestionsPage.vue?vue&type=template&id=2c9e2af5&"
import script from "./TrainingQuestionsPage.vue?vue&type=script&lang=js&"
export * from "./TrainingQuestionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports